import CHAT_MODES from "../constants/modes";
import { Bot } from "lucide-react";

export const chatModesMap = {
    // [CHAT_MODES.TYPE.SSPL_BLOG_Posts]: {
    //     icon: <FileText size={20} />,
    //     label: "SSPL Assistant",
    //     instance_id: "9a14bd2a-6dec-45d1-bd2f-8228fcac5b0e",
    //     application_id: "9a14bd2a-6dec-45d1-bd2f-8228fcac5b0e",
    // },
    // [CHAT_MODES.TYPE.AUTOMOBILE]: {
    //     icon: <Car size={20} />,
    //     label: "Automobile Assistant",
    //     instance_id: "eef099bb-75fb-4e65-89ff-78ba695dc364",
    //     application_id: "eef099bb-75fb-4e65-89ff-78ba695dc364",
    // },
    // [CHAT_MODES.TYPE.NAISS]: {
    //     icon: <BookOpen size={20} />,
    //     label: "NAISS Assistant",
    //     instance_id: "d9d5b5cc-a64c-4010-830e-c64e42a3de11",
    //     application_id: "d9d5b5cc-a64c-4010-830e-c64e42a3de11",
    // },
    // [CHAT_MODES.TYPE.PHARMA]: {
    //     icon: <BriefcaseMedicalIcon size={20} />,
    //     label: "Pharma Assistant",
    //     instance_id: "ecdcf48e-9bc0-4dd6-9583-9db10fd6bf88",
    //     application_id: "ecdcf48e-9bc0-4dd6-9583-9db10fd6bf88",
    // },
    [CHAT_MODES.TYPE.HI_CRM]: {
        icon: <Bot size={20} />,
        label: "Hi CRM",
        instance_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        application_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    },
    [CHAT_MODES.TYPE.HI_BRO]: {
        icon: <Bot size={20} />,
        label: "Hi Bro",
        instance_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        application_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    },  
    [CHAT_MODES.TYPE.UNIFIED]: {
        icon: <Bot size={20} />,
        label: "Unified",
        instance_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        application_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
    },

};
